export default {
    // 葡萄牙语
    LOCALE_HTML: {
        'msg.language': 'pt',
        'msg.title': 'Título',
        'msg.type': 'Categoria de questão',
        'msg.des': 'Descrição do Problema',
        'msg.phone': 'Número de telefone',
        'msg.regionCode': 'Código de área',
        'msg.email': 'E-mail ',
        'msg.choose': 'Por favor selecione uma categoria',
        'msg.detail': 'Detalhes da mensagem',
        'msg.back': 'Retorno',
        'your.msg': 'Por favor,deixe sua mensagem',
        'msg.record': 'Mensagem registrado',
        'msg.success': 'Sucesso da mensagem',
        'to.record': 'Vá para o registro da mensagem',
        completed: 'Completar',
        submit: 'Submetido',
        'success.desc': 'Sua mensagem foi enviada com sucesso, obrigado',
        'msg.form.input': 'Por favor, insira',
        'msg.reply': 'Responder',
        'comment.suc': 'Obrigado pela sua avaliação!',
        'comment.fail': 'Submetido com fracasso',
        'comment.placeholder': 'Sugestões para nossos serviços são bem-vindas',
        'reply.suc': 'Submetido com sucesso',
        'reply.fail': 'Por favor, digite sua resposta',
        'reply.placeholder': 'Por favor, digite sua resposta',
        'msg.more': 'Veja mais',
        'msg.collapse': 'Fecha',
        'msg.myservice': 'Minha avaliação de serviço',
        'msg.evaluate': 'Avaliação de serviço',
        'msg.evaluateTitle': 'Avaliação de serviço',
        'msg.score': 'Avaliação com pontuação',
        'msg.remark': 'Comentários',
        'msg.status.created': 'Criada',
        'msg.status.pending': 'Pendente',
        'msg.status.processing': 'Está pendente',
        'msg.status.solved': 'Completado',
        'msg.service.reply': 'Resposta de atendimento ao cliente',
        'msg.my.reply': 'Sua Resposta',
        'msg.toast.des': 'A descrição da pergunta está vazia',
        'msg.toast.type': 'A categoria da pergunta está vazia',
        'msg.toast.title': 'Título está vazio',
        'msg.toast.none': 'Não pode estar vazio',
        'msg.toast.noAnnex': 'Faça upload do anexo',
        'msg.toast.noEmail': 'O e-mail não pode ficar vazio',
        'msg.toast.noTel': 'O número do telefone não pode estar vazio',
        'msg.toast.noRegionCode': 'O código de área não pode ficar vazio',
        'msg.toast.noZone': 'Selecione um fuso horário',
        'msg.toast.noDateTime': 'Selecione a data e hora',
        'msg.toast.email': 'Por favor insira seu e-mail válido',
        'msg.toast.tel': 'Por favor insira um número de telefone válido',
        'msg.toast.regionCode': 'Por favor selecione o código de área',
        'msg.toast.num': 'Por favor insira o número correto',
        'msg.toast.annex': 'Faça upload do anexo',
        'msg.toast.char': 'Por favor, insira os caracteres corretos',
        'msg.list.none': 'Sem dados',
        'msg.form.choose': 'Por favor escolha',
        'msg.form.chooseZone': 'Selecione o fuso horário',
        'msg.form.chooseTime': 'Selecionar hora',
        'msg.form.chooseDate': 'Selecionar data',
        'msg.form.sure': 'Confirmar',
        'msg.form.search': 'Pesquisar',
        'msg.form.uploadError': 'Formato incorreto',
        'msg.form.uploadXss':
            'Falha no upload, o conteúdo do arquivo contém script ilegal',
        'msg.update.time': 'atualizado em',
        'msg.replace.images': 'foto',

        MSG016: 'Resolvido',
        MSG017: 'Não resolvido',
        MSG019: 'Enviar',
        MSG072: 'O rótulo de avaliação não pode estar vazio! ',
        MSG073: 'A linguagem de avaliação não pode ser vazia! ',
        MSG074: 'Rótulo:',
        MSG075: 'Está resolvido:',
        MSG076: 'Selecione se o problema foi resolvido',
        MSG015: 'Este ticket resolveu seu problema?',

        'file.size.limit': 'O tamanho do arquivo não pode exceder 50 MB',
        'detail.file.limit': '15 no máximo, o tamanho não excede 50M',
        'form.question.des.tip': 'Por favor insira uma descrição do problema',
        'form.title.tip': 'Por favor insira um título',
        'form.class.tip': 'Selecione a categoria do problema',
        'upload.file': 'Faça upload do anexo',
        'file.count.limit': 'Você só pode fazer upload de até 15 anexos',
        'select.search.placeholder': 'Procure a palavra-chave',
        'msg.form.sizeError1': 'Faça upload de anexos menores que 5M',
        'msg.form.sizeError2': 'Faça upload de anexos menores que 50M',
        'msg.form.submit': 'Submetendo',
        'msg.form.upload': 'Enviando',
        'msg.email.tip1': 'Não encontrou sua mensagem',
        'msg.email.tip2':
            'Se você deixou uma mensagem antes, você pode verificá-la por verificação de e-mail',
        'msg.email.tip3': 'Iniciar verificação de e-mail',
        'msg.email.noData': 'Sem dados na conta atualmente',
        'email.verify.tip':
            'Digite o endereço de e-mail usado ao deixar uma mensagem',
        'email.input.placeholder': 'Por favor insira o endereço de e-mail',
        'email.submit': 'Enviar e-mail',
        'email.rules.error': 'Por favor insira seu e-mail válido',
        'email.code.tip':
            'O e-mail foi enviado, digite o código de verificação que você recebeu',
        'email.code.placeholder': 'Por favor insira o código de verificação',
        'email.code.submit': 'Veja Agora',
        'email.notFind.customer': 'Informação do cliente não foi encontrada',
        'email.code.wrong':
            'O código de verificação está errado, digite novamente',
        'email.code.expired':
            'O código de verificação expirou, verifique novamente o e-mail',
        'email.code': 'Código de verificação',
        'email.send.frequently':
            'A operação é muito frequente, tente novamente mais tarde',
        'comment.fail.400133': 'Este bilhete foi avaliado',
        'not.get.user.info': 'Não foi possível obter as suas informações',
        'user.verify.tip':
            'Você precisa verificar antes de poder visualizar o conteúdo da lista de mensagens',
        'verify.type.email': 'Verificação de e-mail',
        'verify.text': 'validar',
        'cancel.text': 'cancelar',
        'get.verify.code': 'Obter código de verificação',
        'reGet.verify.code': 'Reacquire ',
        'verify.by.email.tip':
            'O código de verificação será enviado por e-mail para a conta de e-mail que você inseriu',
        'verify.type.phone': 'Verificação SMS',
        'phone.placeholder': 'Número de telemóvel',
        'verify.by.phone.tip':
            'O código de verificação será enviado via SMS para o número de telefone que você digitou',
        'phone.error': 'Introduza o número de telefone correcto',
        'phone.errorCode400150': 'Envio frequente de códigos de verificação',
        'phone.errorCode400233': 'O modelo SMS não pode estar vazio',
        'phone.errorCode400234': 'Saldo insuficiente de SMS de marketing',
        'phone.errorCode400235': 'Saldo SMS de notificação insuficiente',
        'phone.errorCode400247':
            'Erro de configuração do SMS do plugin de ordem de trabalho',
        'phone.errorCode4400248': 'Não foi possível obter o modelo SMS',
        'phone.errorCode400249':
            'Este número não é o número de telefone de um usuário existente',
        'phone.errorCode400250':
            'O código de verificação expirou, obtenha-o novamente',
        'msg.you.reply': 'Voltei para você',
        'msg.no.reply':'Sem resposta',
    },
    LOCALE_REQUEST: {
        400016: 'A obtenção de informações da ordem de serviço expirou.'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'excluir',
                cancel: 'Cancelar',
                confirm: 'Claro',
                inert: 'inserir',
                width: 'largura',
                height: 'alto'
            },
            controls: {
                clear: 'conteúdo claro',
                undo: 'revogar',
                redo: 'refazer',
                fontSize: 'tamanho da fonte',
                lineHeight: 'altura da linha',
                letterSpacing: 'espaçamento entre palavras',
                textIndent: 'recuo de parágrafo',
                increaseIndent: 'aumentar recuo',
                decreaseIndent: 'reduzir recuo',
                border: 'quadro',
                color: 'cor',
                textColor: 'cor do texto',
                backgroundColor: 'cor de fundo',
                tempColors: 'cor temporária',
                bold: 'audacioso',
                italic: 'itálico',
                underline: 'sublinhado',
                strikeThrough: 'tachado',
                fontFamily: 'Fonte',
                textAlign: 'alinhamento de texto',
                alignLeft: 'esquerda',
                alignCenter: 'no centro',
                alignRight: 'Certo',
                alignJustify: 'ambos os finais',
                floatLeft: 'flutuar para a esquerda',
                floatRight: 'flutuar para a direita',
                superScript: 'Sobrescrito',
                subScript: 'subscrito',
                removeStyles: 'estilo claro',
                headings: 'título',
                header: 'título',
                normal: 'convencional',
                orderedList: 'lista ordenada',
                unorderedList: 'lista não ordenada',
                blockQuote: 'citar',
                code: 'o código',
                link: 'Link',
                unlink: 'link claro',
                hr: 'linha horizontal',
                media: 'meios de comunicação',
                mediaLibirary: 'Biblioteca de mídia',
                emoji: 'pequena expressão',
                fullscreen: 'tela cheia',
                exitFullscreen: 'Sair da Tela Cheia'
            },
            linkEditor: {
                textInputPlaceHolder: 'insira o texto do link',
                linkInputPlaceHolder: 'Digite o endereço do link',
                inputWithEnterPlaceHolder:
                    'Digite o endereço do link e pressione Enter',
                openInNewWindow: 'abrir em nova janela',
                removeLink: 'remover link'
            },
            audioPlayer: {
                title: 'reproduzir arquivo de áudio'
            },
            videoPlayer: {
                title: 'reproduzir arquivo de vídeo',
                embedTitle: 'mídia incorporada'
            },
            media: {
                image: 'imagem',
                video: 'vídeo',
                audio: 'áudio',
                embed: 'mídia incorporada'
            }
        },
        finder: {
            remove: 'excluir',
            cancel: 'Cancelar',
            confirm: 'confirme',
            insert: 'inserir item selecionado',
            width: 'largura',
            height: 'alto',
            image: 'foto',
            video: 'vídeo',
            audio: 'áudio',
            embed: 'mídia incorporada',
            caption: 'Biblioteca de mídia',
            dragTip: 'Clique ou arraste o arquivo aqui',
            dropTip: 'Solte para carregar',
            selectAll: 'selecionar tudo',
            deselect: 'cancelar seleção',
            removeSelected: 'excluir item selecionado',
            externalInputPlaceHolder: 'Nome do recurso|Endereço do recurso',
            externalInputTip: `Use "|" para separar o nome do recurso e o endereço do recurso`,
            addLocalFile: 'Adicionar recursos locais',
            addExternalSource: 'Adicionar recurso da web',
            unnamedItem: 'projeto sem título',
            confirmInsert: 'Inserir item selecionado'
        }
    }
}
